export const SCOPE_CATEGORIES = [
  {
    id: 'read_only',
    name: 'Read Only',
    description: 'View resources, networks, snapshots, billing',
    scopes: ['resources:read', 'networks:read', 'snapshots:read', 'billing:read', 'tenants:read'],
  },
  {
    id: 'deploy',
    name: 'Deploy',
    description: 'Create and manage resources and networks',
    scopes: ['resources:read', 'resources:create', 'resources:update', 'resources:delete', 'networks:read', 'networks:create', 'networks:update', 'networks:delete'],
  },
  {
    id: 'automation',
    name: 'Automation',
    description: 'Full resource management with credentials and snapshots',
    scopes: ['resources:read', 'resources:create', 'resources:update', 'resources:delete', 'resources:manage_credentials', 'resources:manage_snapshots', 'networks:read', 'networks:create', 'networks:update', 'networks:delete', 'snapshots:read', 'snapshots:create', 'snapshots:delete'],
  },
  {
    id: 'monitoring',
    name: 'Monitoring',
    description: 'Read access for monitoring and alerting',
    scopes: ['resources:read', 'networks:read', 'snapshots:read', 'billing:read', 'tenants:read'],
  },
] as const

export type ScopeCategoryId = (typeof SCOPE_CATEGORIES)[number]['id']
